// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n#main[data-v-08da331d] {\n  color: white;\n  background-color: #222222;\n  min-height: 1350px;\n  min-width: 300px;\n  display: flex;\n  justify-content: center;\n  /* 수평 가운데 정렬 */\n  /* align-items: center; */\n  /* overflow: auto; */\n}\n\n/* .min {\n\tmin-width: 1350px !important;\n} */\n/* .min {\n\tmin-width: 1350px !important;\n}\n@media (min-width: 768px) {\n  #main {\n    min-height: 800px;\n  }\n} */", ""]);
// Exports
module.exports = exports;
